import dayjs from "dayjs";

export function calculateFilterExpression(filterValue: any) {
  return ["json", "contains", filterValue];
}

export function defaultFilterExpression(column: string, filterValue: any) {
  return [column, "contains", filterValue];
}

export function defaultFilterEqualExpression(column: string, filterValue: any) {
  return [column, "=", filterValue];
}

export function calculateDateField(filterValue: any, selectedFilterOperation: any) {
  switch (selectedFilterOperation) {
    case "between":
      if (Array.isArray(filterValue)) {
        return [
          //@ts-ignore
          [this.dataField, ">", dayjs(filterValue[0]).toISOTzRemove()],
          "and",
          // @ts-ignore
          [this.dataField, "<", dayjs(filterValue[1]).add(1, "day").toISOTzRemove()],
        ];
      }
      break;
    case "=":
      return [
        //@ts-ignore
        [this.dataField, ">=", dayjs(filterValue).toISOTzRemove()],
        "and",
        // @ts-ignore
        [this.dataField, "<", dayjs(filterValue).add(1, "day").toISOTzRemove()],
      ];

    case "<>":
      return [
        //@ts-ignore
        [this.dataField, "<", dayjs(filterValue).toISOTzRemove()],
        "or",
        // @ts-ignore
        [this.dataField, ">=", dayjs(filterValue).add(1, "day").toISOTzRemove()],
      ];
    case "<":
      //@ts-ignore
      return [this.dataField, "<", dayjs(filterValue).toISOTzRemove()];
    case ">":
      //@ts-ignore
      return [this.dataField, ">=", dayjs(filterValue).add(1, "day").toISOTzRemove()];
    case "<=":
      //@ts-ignore
      return [this.dataField, "<", dayjs(filterValue).add(1, "day").toISOTzRemove()];
    case ">=":
      //@ts-ignore
      return [this.dataField, ">=", dayjs(filterValue).toISOTzRemove()];
  }
}
